document.addEventListener("DOMContentLoaded", initSansuVideoCarousel);
document.addEventListener("shopify:section:load", initSansuVideoCarousel);

function initSansuVideoCarousel() {

  document.querySelectorAll(".sansu-video-swiper").forEach((slider) => {

    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }

    new Swiper(slider, {

      slidesPerView: Number(slider.dataset.mobile),
      spaceBetween: Number(slider.dataset.space),

      observer: true,
      observeParents: true,
      resizeObserver: true,

      watchOverflow: true,

      loop: slider.dataset.loop === "true",

      autoplay: slider.dataset.autoplay === "true"
        ? {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }
        : false,

      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev")
      },

      pagination: {
        el: slider.querySelector(".swiper-pagination"),
        clickable: true
      },

      breakpoints: {
        0: {
          slidesPerView: Number(slider.dataset.mobile)
        },
        750: {
          slidesPerView: Number(slider.dataset.tablet)
        },
        990: {
          slidesPerView: Number(slider.dataset.desktop)
        }
      }

    });

  });

  initVideoPopup();

}

function initVideoPopup() {

  const modal = document.getElementById("sansu-video-modal");

  if (!modal) return;

  const player = document.getElementById("sansu-video-player");

  document.querySelectorAll(".sansu-video-thumbnail").forEach((thumb) => {

    const card = thumb.closest(".sansu-video-card");

    thumb.onclick = function () {

      const type = card.dataset.videoType;

      player.innerHTML = "";

      if (type === "youtube") {

        player.innerHTML = `
          <iframe
            src="https://www.youtube.com/embed/${card.dataset.videoId}?autoplay=1"
            allow="autoplay; encrypted-media"
            allowfullscreen>
          </iframe>
        `;

      } else if (type === "vimeo") {

        player.innerHTML = `
          <iframe
            src="https://player.vimeo.com/video/${card.dataset.videoId}?autoplay=1"
            allow="autoplay"
            allowfullscreen>
          </iframe>
        `;

      } else if (type === "shopify") {

        player.innerHTML = `
          <video controls autoplay style="width:100%;">
            <source src="${card.dataset.video}">
          </video>
        `;

      }

      modal.classList.add("active");

      document.body.style.overflow = "hidden";

      document.querySelectorAll(".sansu-video-swiper").forEach((slider) => {
        if (slider.swiper && slider.swiper.autoplay) {
          slider.swiper.autoplay.stop();
        }
      });

    };

  });

  modal.querySelector(".sansu-video-close").onclick = closeVideo;
  modal.querySelector(".sansu-video-modal-overlay").onclick = closeVideo;

  document.addEventListener("keydown", function(e) {
    if (e.key === "Escape") {
      closeVideo();
    }
  });

  function closeVideo() {

    modal.classList.remove("active");

    player.innerHTML = "";

    document.body.style.overflow = "";

    document.querySelectorAll(".sansu-video-swiper").forEach((slider) => {
      if (slider.swiper && slider.swiper.autoplay) {
        slider.swiper.autoplay.start();
      }
    });

  }

}
